module.exports = __webpack_public_path__ + "d127808d0f127c239d86749e8319d705.png";